import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FamilyFunctionalStatusResponse } from '../types/operator';
import { AppApiService } from './app-api.service';

@Injectable({
  providedIn: 'root',
})
export class CrmApiService {
  protected baseEndpoint = environment.crm.backend.baseEndpoint;
  protected c1Host = environment.c1BusinessManager.host;

  constructor(protected api: AppApiService) {}

  isFamilyFunctionalAvailable(): Observable<boolean> {
    return this.api.get<FamilyFunctionalStatusResponse>(`${this.baseEndpoint}family-functional-available`).pipe(
      map(response => response.familyFunctionalIsAvailable),
      catchError(() => of(null)),
    );
  }
}
